// defined constant type
export enum RegionType {
  DOMESTIC_CHANNEL = 1,
  DOMESTIC_DISTRIBUTOR = 3,
  DOMESTIC_ONLINE = 4,
  DOMESTIC_DEPART = 5,
  FOREIGN = 2,
}
export const regionTypeOptions = [
  {
    label: "台灣本地通路",
    value: RegionType.DOMESTIC_CHANNEL,
  },
  {
    label: "台灣本地經銷",
    value: RegionType.DOMESTIC_DISTRIBUTOR,
  },
  {
    label: "台灣線上通路",
    value: RegionType.DOMESTIC_ONLINE,
  },
  {
    label: "台灣實體百貨",
    value: RegionType.DOMESTIC_DEPART,
  },
  {
    label: "境外通路",
    value: RegionType.FOREIGN,
  },
];

export const regionTypeName: Record<RegionType, string> = {
  [RegionType.DOMESTIC_CHANNEL]: "台灣本地通路",
  [RegionType.DOMESTIC_DISTRIBUTOR]: "台灣本地經銷",
  [RegionType.DOMESTIC_ONLINE]: "台灣線上通路",
  [RegionType.DOMESTIC_DEPART]: "台灣實體百貨",
  [RegionType.FOREIGN]: "境外通路",
};

export const convertRegionType = (type?: RegionType) => {
  switch (type) {
    case RegionType.DOMESTIC_CHANNEL:
      return "台灣本地通路";
    case RegionType.FOREIGN:
      return "境外通路";
    case RegionType.DOMESTIC_ONLINE:
      return "台灣線上通路";
    case RegionType.DOMESTIC_DEPART:
      return "台灣實體百貨";
    case RegionType.DOMESTIC_DISTRIBUTOR:
      return "台灣本地經銷";
    default:
      return "";
  }
};

export const salesChannelPrefixMap = {
  [RegionType.DOMESTIC_CHANNEL]: ["實體", "其他"],
  [RegionType.DOMESTIC_DISTRIBUTOR]: ["經銷商"],
  [RegionType.DOMESTIC_ONLINE]: ["B2B", "B2C"],
  [RegionType.FOREIGN]: ["跨境", "其他"],
  [RegionType.DOMESTIC_DEPART]: ["實體"],
};

// 結帳模式
export enum InvoiceMode {
  AUTO_INVOICE = 1,
  THIRD_PARTY_FILL = 2,
  MONTHLY_STATEMENT = 3,
}
export const invoiceModeOptions = [
  { label: "系統自動開發票", value: InvoiceMode.AUTO_INVOICE },
  { label: "代開回填", value: InvoiceMode.THIRD_PARTY_FILL },
  { label: "月對帳單", value: InvoiceMode.MONTHLY_STATEMENT },
];

export enum Currency {
  TWD = 1,
  USD = 2,
  RMB = 3,
}
export const convertCurrencyType = (type: Currency) => {
  switch (type) {
    case Currency.TWD:
      return "TWD";
    case Currency.USD:
      return "USD";
    case Currency.RMB:
      return "RMB";
    default:
      return "";
  }
};
export enum ContractType {
  BUYOUT_REFUNDABLE = 1,
  BUY_AND_NOT_RETURN = 2,
  CONSIGNMENT = 3,
  TRANSFER = 4,
}
export const convertContractType = (type: ContractType) => {
  switch (type) {
    case ContractType.BUYOUT_REFUNDABLE:
      return "買斷可退";
    case ContractType.BUY_AND_NOT_RETURN:
      return "買斷不可退";
    case ContractType.CONSIGNMENT:
      return "寄倉";
    case ContractType.TRANSFER:
      return "轉單";
    default:
      return "";
  }
};

export enum Incoterms {
  FOB = "FOB",
  CIF = "CIF",
  EXW = "EXW",
  DDU = "DDU",
}
export enum ApprovalStatus {
  NOT_REQUIRED = 0,
  PENDING = 1,
  AUDIT = 2,
  APPROVED = 3,
  REJECTED = 4,
  INVALID = 5,
}
export const convertApprovalStatus = (type: ApprovalStatus) => {
  switch (type) {
    case ApprovalStatus.PENDING:
      return "待審核";
    case ApprovalStatus.APPROVED:
      return "審核已通過";
    case ApprovalStatus.REJECTED:
      return "審核未通過";
    case ApprovalStatus.AUDIT:
      return "審核中";
    case ApprovalStatus.INVALID:
      return "作廢";
    case ApprovalStatus.NOT_REQUIRED:
      return "不需審核";
    default:
      return "";
  }
};
export enum ShippingStatus {
  CANCELLED_W_DEPLOYED = -1,
  WAITING_TO_DEPLOY = 0,
  DEPLOY_SUCCESS = 1,
  OUT_OF_STOCK = 3,
  PROCESS = 4,
  SHIPPED = 5,
  CENTRE = 6,
  PICKUP = 7,
  SHIPPING_ABNORMAL = 8,
}
export enum AmountRateType {
  RATE = 1,
  AMOUNT = 2,
}
export enum RetailVsCodeFilter {
  HAS_VS_CODE = 1,
}

export enum PickupType {
  SELF_PICKUP = 0,
  CHARTER = 1,
  HCT_CHARTER = 2,
  T_CAT = 3,
}

export enum PickupTypeByValue {
  "訂單自取" = 0,
  "訂單非自取 (專車)" = 1,
  "訂單非自取 (新竹)" = 2,
  "訂單非自取 (黑貓)" = 3,
}

export const enum DeductionType {
  PRE_DEDUCTION = 1,
  POST_DEDUCTION = 2,
}
